import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Textarea from 'react-textarea-autosize';
import {
  FormGroup,
  FormControl,
} from 'react-bootstrap';

import validation from '../../lib/validation';
import { updateField } from '../../actions/form';

export class FieldTextArea extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = {
      isFocused: false,
      validationState: null,
      value: '',
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.toggleFocused = this.toggleFocused.bind(this);
    this.updateStore = _.debounce(this.updateStore, 200);
  }

  componentDidMount() {
    this.setState({ value: this.props.fieldValue });

    if (!_.isEmpty(this.props.fieldValue)) {
      this.validateInput(this.props.fieldValue);
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.state.isFocused && this.props.fieldValue !== prevProps.fieldValue) {
      this.setState({ value: this.props.fieldValue });
      this.validateInput(this.props.fieldValue);
    }
  }

  onInputChange(e) {
    this.setState({ value: e.target.value });
    this.validateInput(e.target.value);
    this.updateStore(e.target.value);
  }

  validateInput(value) {
    if (!_.isEmpty(value) || _.get(this.props, 'validation.required')) {
      this.setState({ validationState: validation.run(this.props.validation, value) ? 'success' : 'error' });
    } else {
      this.setState({ validationState: null });
    }
  }

  updateStore(value) {
    this.props.updateField(this.props.type, this.props.field, value);
  }

  toggleFocused(isFocused) {
    this.setState({ isFocused });
  }

  render() {
    return (
      <FormGroup validationState={this.state.validationState}>
        <Textarea
          minRows={this.props.rows || 1}
          name={this.props.title}
          className="select-feedback"
          onChange={this.onInputChange}
          onFocus={() => this.toggleFocused(true)}
          onBlur={() => this.toggleFocused(false)}
          placeholder={this.props.placeholder}
          value={this.state.value || ''}
        />
        <FormControl.Feedback className="textarea-feedback" />
      </FormGroup>
    );
  }
}

export const mapStateToProps = (state, ownProps) => ({
  fieldValue: _.get(state, `form.${state.ui.ratingType}.fields.${ownProps.field}`),
  type: _.get(state, 'ui.ratingType'),
  validation: _.get(state, `validation.${state.ui.ratingType}.fields.${ownProps.field}`),
});

export default connect(
  mapStateToProps,
  { updateField },
)(FieldTextArea);
